export default {
    layout(state) {
        let layout = state.layout||'DefaultLayout';
        return layout;
    }
};